module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/2000-04-06/2-a31eca0a088d7b92f7afff9a80583303.jpg";